import { setConfig } from './globals';
import * as launches from './launches/launches';
import * as stations from './stations/stations';
import * as passes from './stations/pass';
import * as search from './misc/search';
import * as mapbox from './services/mapbox';
import * as tags from './launches/tags';
import * as articles from './editorial/articles';
import * as contributors from './editorial/contributors';
import * as agencies from './adb/agencies';
import * as astronauts from './adb/astronauts';
import * as adb from './adb/adb';
import * as awards from './adb/awards';
import * as crafts from './adb/crafts';
import * as missions from './adb/missions';
import * as nations from './adb/nations';
import * as facts from './misc/facts';
import * as glossary from './misc/glossary';
import * as notifications from './misc/notifications';
import * as pages from './misc/pages';
import { configureShopifyClient } from './services/shopify';
import * as shopify from './services/shopify';
import { configureSanityClient } from './services/sanity';
import * as sanity from './services/sanity';
// In progress, moving to a factory pattern to pass config to all functions
export const createSuperclient = (config, contentfulClient, contentfulPreviewClient) => {
    setConfig(config);
    const shopifyClient = configureShopifyClient(config);
    const sanityClient = configureSanityClient(config);
    const boundFunctions = {
        // Launches
        getLaunch: launches.getLaunch.bind(null, config),
        getLaunchBySlug: launches.getLaunchBySlug.bind(null, config),
        getUpcomingLaunches: launches.getUpcomingLaunches.bind(null, config),
        getNextLaunch: launches.getNextLaunch.bind(null, config),
        getPastLaunches: launches.getPastLaunches.bind(null, config),
        useLaunch: launches.useLaunch.bind(null, config),
        useNextLaunch: launches.useNextLaunch.bind(null, config),
        getTags: tags.getTags.bind(null, config),
        // Editorial
        getArticles: articles.getArticles.bind(null, contentfulClient),
        getArticleBySlug: articles.getArticleBySlug.bind(null, contentfulClient),
        useArticle: articles.useArticle.bind(null, contentfulClient),
        getPreviewArticle: articles.getPreviewArticle.bind(null, contentfulPreviewClient),
        getContributors: contributors.getContributors.bind(null, contentfulClient),
        // ADB
        getAgencies: agencies.getAgencies.bind(null, config),
        getAstronaut: astronauts.getAstronaut.bind(null, config),
        getAstronautBySlug: astronauts.getAstronautBySlug.bind(null, config),
        useAstronaut: astronauts.useAstronaut.bind(null, config),
        getMinifiedAstronauts: adb.getMinifiedAstronauts.bind(null, config),
        getAwardTypes: awards.getAwardTypes.bind(null, config),
        getCrafts: crafts.getCrafts.bind(null, config),
        getMission: missions.getMission.bind(null, config),
        getMissions: missions.getMissions.bind(null, config),
        getMissionBySlug: missions.getMissionBySlug.bind(null, config),
        useMission: missions.useMission.bind(null, config),
        getNations: nations.getNations.bind(null, config),
        // Stations
        getStations: stations.getStations.bind(null, config),
        getStation: stations.getStation.bind(null, config),
        getStationBySlug: stations.getStationBySlug.bind(null, config),
        getPasses: passes.getPasses.bind(null, config),
        deriveStationPortLayouts: stations.deriveStationPortLayouts.bind(null, sanityClient),
        deriveStationCraftImageUrl: stations.deriveStationCraftImageUrl.bind(null, sanityClient),
        // Search
        getSearchSuggestions: search.getSearchSuggestions.bind(null, config),
        getSearchResults: search.getSearchResults.bind(null, config),
        useSearch: search.useSearch.bind(null, config),
        performSearchQuery: search.performSearchQuery.bind(null, config),
        // Shop
        getShopIndexConfig: shopify.getShopIndexConfig.bind(null, config),
        getShopifyProducts: shopify.getShopifyProducts.bind(null, shopifyClient),
        getShopifyProduct: shopify.getShopifyProduct.bind(null, shopifyClient),
        getShopifyStoreCollection: shopify.getShopifyStoreCollection.bind(null, config, shopifyClient),
        // Mapbox
        performLocationSearch: mapbox.performLocationSearch.bind(null, config),
        reverseGeocode: mapbox.reverseGeocode.bind(null, config),
        // Misc
        getContentfulFacts: facts.getContentfulFacts.bind(null, contentfulClient),
        getGlossaryTerms: glossary.getGlossaryTerms.bind(null, config),
        getNotification: notifications.getNotification.bind(null, config),
        getNotificationBySlug: notifications.getNotificationBySlug.bind(null, config),
        useNotification: notifications.useNotification.bind(null, config),
        getContentfulPages: pages.getContentfulPages.bind(null, contentfulClient),
        getImageUrl: sanity.getImageUrl.bind(null, sanityClient)
    };
    return boundFunctions;
};
//# sourceMappingURL=factory.js.map